import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout'

// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage'

// Okta Auth
import Login from 'src/components/Dashboard/Views/Login/Login'

// Projects
import ProjectsSearch from 'src/components/Dashboard/Views/Projects/Search'
import ProjectContainer from 'src/components/Dashboard/Views/Projects/ProjectContainer'

// Jobs
import JobsSearch from 'src/components/Dashboard/Views/Jobs/Search'
import JobTemplates from 'src/components/Dashboard/Views/Jobs/Templates'

// Tasks
import TasksSearch from '@/components/Dashboard/Views/Tasks/Search'
import MyTasks from 'src/components/Dashboard/Views/Tasks/MyTasks'
import TaskNames from 'src/components/Dashboard/Views/TaskNames/Search'
import TaskTemplates from '@/components/Dashboard/Views/TaskTemplates/Search'

// Invoices
import CreateInvoices from 'src/components/Dashboard/Views/Invoices/CreateInvoices'
import SearchInvoices from 'src/components/Dashboard/Views/Invoices/Search'

// Companies
import CompaniesSearch from '@/components/Dashboard/Views/Companies/Search'

import CitySearch from 'src/components/Dashboard/Views/Cities/Search'

// InTouch
import InTouchGps from 'src/components/Dashboard/Views/InTouch/Map'

// Users
import UsersSearch from 'src/components/Dashboard/Views/Users/Search'
import Notifications from 'src/components/Dashboard/Views/Users/Notifications'

// Logs
import LogsSearch from 'src/components/Dashboard/Views/Logs/Search'

// History
import HistorySearch from '@/components/Dashboard/Views/History/Search.vue'

// Admin
import CamundaDeployments from 'src/components/Dashboard/Views/Camunda/CamundaDeployments'
import Communities from 'src/components/Dashboard/Views/Communities/Search'
import Dashboard from 'src/components/Dashboard/Views/Dashboard/Overview'
import InspectorApp from 'src/components/Dashboard/Views/InspectorApp/Index'
import InspectorRouting from 'src/components/Dashboard/Views/InspectorRouting/InspectorRouting.vue'
import ItemCodes from 'src/components/Dashboard/Views/QuickBooks/ItemCodes'
import Files from 'src/components/Dashboard/Views/Files/Search'
import FlexmonsterReports from 'src/components/Dashboard/Views/Reports/FlexmonsterReports'
import FlexmonsterGenerateData from 'src/components/Dashboard/Views/Reports/FlexmonsterGenerateData'
import LegalSubdivisions from 'src/components/Dashboard/Views/LegalSubdivisions/Search'
import PlanNames from 'src/components/Dashboard/Views/PlanNames/Search'
import PriceRules from 'src/components/Dashboard/Views/PriceRules/Search'
import PurchaseOrders from 'src/components/Dashboard/Views/SupplyPro/PurchaseOrders'
import PurchaseOrder from 'src/components/Dashboard/Views/SupplyPro/PurchaseOrder'
import Reports from '@/components/Dashboard/Views/Reports/Reports'
import Streets from 'src/components/Dashboard/Views/Streets/Search'
import Tools from 'src/components/Dashboard/Views/Tools/Dashboard'
import IDAArchive from 'src/components/Dashboard/Views/IDAArchive/Search'

const projectsMenu = {
  path: '/projects',
  component: DashboardLayout,
  redirect: '/projects/search',
  children: [
    {
      path: 'search',
      name: 'Projects',
      component: ProjectsSearch,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: ':id',
      name: 'Project',
      component: ProjectContainer,
      props: true,
      meta: {
        requiresAuth: true
      }
    }
  ]
}

const usersMenu = {
  path: '/users',
  component: DashboardLayout,
  redirect: '/users/notifications',
  children: [
    {
      path: 'notifications',
      name: 'Notifications',
      component: Notifications,
      meta: {
        requiresAuth: true
      }
    }
  ]
}

const jobsMenu = {
  path: '/jobs',
  component: DashboardLayout,
  redirect: '/jobs/search',
  children: [
    {
      path: 'search',
      name: 'Jobs Search',
      component: JobsSearch,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'templates',
      name: 'TaskTemplates',
      component: JobTemplates,
      meta: {
        requiresAuth: true
      }
    }
  ]
}

const logsMenu = {
  path: '/logs',
  component: DashboardLayout,
  redirect: '/logs/search',
  children: [
    {
      path: 'search',
      name: 'Logs Search',
      component: LogsSearch,
      meta: {
        requiresAuth: true
      }
    }
  ]
}

const historyMenu = {
  path: '/history',
  component: DashboardLayout,
  redirect: '/history/search',
  children: [
    {
      path: 'search',
      name: 'History Search',
      component: HistorySearch,
      meta: {
        requiresAuth: true
      }
    }
  ]
}

const tasksMenu = {
  path: '/tasks',
  component: DashboardLayout,
  redirect: '/tasks/search',
  children: [
    {
      path: 'search',
      name: 'Tasks Search',
      component: TasksSearch,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'my-tasks',
      name: 'My Tasks',
      component: MyTasks,
      meta: {
        requiresAuth: true
      }
    }
  ]
}

const invoicesMenu = {
  path: '/invoices',
  component: DashboardLayout,
  redirect: '/invoices/create',
  children: [
    {
      path: 'create',
      name: 'Create Invoices',
      component: CreateInvoices,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'search',
      name: 'Search Invoices',
      component: SearchInvoices,
      meta: {
        requiresAuth: true
      }
    }
  ]
}

const inTouchMenu = {
  path: '/in-touch',
  component: DashboardLayout,
  redirect: '/in-touch/map',
  children: [
    {
      path: 'map',
      name: 'InTouch GPS',
      component: InTouchGps,
      meta: {
        requiresAuth: true
      }
    }
  ]
}

const adminMenu = {
  path: '/admin',
  component: DashboardLayout,
  redirect: '/admin/dashboard',
  children: [
    {
      path: 'camunda-deployments',
      name: 'Camunda Deployments',
      component: CamundaDeployments,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'cities',
      name: 'Cities',
      component: CitySearch,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'communities',
      name: 'Communities',
      component: Communities,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'companies',
      name: 'Companies',
      component: CompaniesSearch,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'files',
      name: 'Files',
      component: Files,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'reports',
      name: 'Reports',
      component: Reports,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'reports/flexmonster/generate',
      name: 'Flexmonster Generate Data',
      component: FlexmonsterGenerateData,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'reports/flexmonster',
      name: 'Flexmonster Reports',
      component: FlexmonsterReports,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'ida-archive',
      name: 'IDA Archive',
      component: IDAArchive,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'inspector-app',
      name: 'Inspector App',
      component: InspectorApp,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'inspector-routing',
      name: 'Inspector Routing',
      component: InspectorRouting,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'legal-subdivisions',
      name: 'Legal Subdivisions',
      component: LegalSubdivisions,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'plan-names',
      name: 'Plan Names',
      component: PlanNames,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'price-rules',
      name: 'Price Rules',
      component: PriceRules,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'quickbooks/item-codes',
      name: 'QuickBooks Item Codes',
      component: ItemCodes,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'streets',
      name: 'Streets',
      component: Streets,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'supply-pro',
      name: 'Supply Pro Purchase Orders',
      component: PurchaseOrders,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'supply-pro/:purchaseOrderId',
      name: 'Supply Pro Purchase Order',
      component: PurchaseOrder,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'task-names',
      name: 'Task Names',
      component: TaskNames,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'task-templates',
      name: 'Task Templates',
      component: TaskTemplates,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'tools',
      name: 'Tools',
      component: Tools,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'users',
      name: 'Users',
      component: UsersSearch,
      meta: {
        requiresAuth: true
      }
    }
  ]
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: DashboardLayout,
    redirect: '/projects/search'
  },
  {
    path: '/login',
    component: Login
  },
  // {
  //   path: '/login/callback',
  //   component: LoginCallback
  // },
  projectsMenu,
  jobsMenu,
  logsMenu,
  historyMenu,
  tasksMenu,
  invoicesMenu,
  usersMenu,
  inTouchMenu,
  adminMenu,
  {path: '*', component: NotFound}
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes
